<template>
	<InfoPill>
		<div class="flex items-center gap-2">
			<WarningCircleFill class="size-5 shrink-0"></WarningCircleFill>
			<div>Tato zpráva není podporována</div>
		</div>
	</InfoPill>
</template>

<script setup lang="ts">
import type { Props } from '@/types/Message'
const props = defineProps<Props>()

import InfoPill from '../InfoPill.vue'
import WarningCircleFill from '@/assets/icons/warning-circle-fill.svg'
</script>

<style scoped></style>
